import * as React from 'react';
import { useDispatch } from 'react-redux';

import { openChatCustomActionModal } from '../../actions/chatCustomActionModal';
import { UserCardDesktopCustomActionButton } from '../../components/UserCard/UserCardDesktopCustomActionButton';
import { useCurrentChatCompanionData } from '../../hooks';
import { sendCustomActions } from '../../services/sendCustomActions';
import { TCustomAction } from '../../types/customActions';

interface ICustomActionButtonContainerProps {
  button: TCustomAction;
  chatId: string;
}

export const UserCardCustomActionButtonContainer: React.FC<ICustomActionButtonContainerProps> = ({
  button,
  chatId,
}) => {
  const dispatch = useDispatch();
  const { companionId } = useCurrentChatCompanionData(chatId);

  const { action, alert, longText } = button;

  const handleClickCustomAction = () => {
    if (alert) {
      dispatch(
        openChatCustomActionModal({
          text: alert.text,
          cancelButtonText: alert.cancelButtonText,
          confirmButtonText: alert.confirmButtonText,
          action,
          chatId,
        }),
      );

      return;
    }

    dispatch(sendCustomActions({ chatId, action, companionId }));
  };

  return <UserCardDesktopCustomActionButton onClick={handleClickCustomAction} action={action} longText={longText} />;
};
